// utils/auth.js
import { jwtDecode } from 'jwt-decode'; // <-- Ubah baris ini
import Cookies from 'js-cookie';

export const getUserLevel = () => {
  try {
    const token = Cookies.get('access_token');
    
    if (token) {
      const decodedToken = jwtDecode(token);
      return decodedToken.level;
    }
    return null;
  } catch (error) {
    console.error("Gagal men-decode token:", error);
    return null; 
  }
};